import script from "./reference-selector.vue?vue&type=script&setup=true&lang=js"
export * from "./reference-selector.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__